import React from 'react';

import { Box, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import type { AiCodeFieldSelections as FieldSelections } from '~/services/aiCodeFieldSelections';

export default function AiCodeFieldSelections({ selections }: { selections: FieldSelections }) {
  return (
    <Stack spacing={2}>
      {(
        [
          ['ai', 'Fields supplied by AI'],
          ['application', 'Application selections'],
          ['defaults', 'Schema defaults for omitted fields'],
        ] as const
      ).map(([key, title]) => (
        <Box key={key}>
          <Typography variant="subtitle1">{title}</Typography>
          {selections[key].length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              {key === 'defaults'
                ? 'No explicit schema defaults to display. Omitted update fields remain unchanged.'
                : 'None.'}
            </Typography>
          ) : (
            <Table size="small" aria-label={title} sx={{ tableLayout: 'fixed' }}>
              <TableHead>
                <TableRow>
                  <TableCell>Field</TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selections[key].map(({ field, value }) => (
                  <TableRow key={field}>
                    <TableCell sx={{ overflowWrap: 'anywhere' }}>{field}</TableCell>
                    <TableCell sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                      {JSON.stringify(value)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Box>
      ))}
    </Stack>
  );
}
